import RelatedProduct from './related-product';
import { Swiper, SwiperSlide } from 'swiper/react';
import RelatedProductSkeleton from '@/components/ui/skeletons/RelatedProductSkeleton';

export default function Recommendations({
  items,
  t,
  isRelatedProductsLoading,
}) {
  return (
    <div className='rounded-[14px] border border-dashed border-[#e2e8f0] p-2.5'>
      <h4 className='m-0 mb-2 text-[14px]'>{t('suggestions_for_you')}</h4>
      <Swiper
        spaceBetween={16}
        slidesPerView={3}
        navigation={{
          prevEl: '.prev-button',
          nextEl: '.next-button',
        }}
      >
        {isRelatedProductsLoading
          ? [...Array(6)].map((_, i) => (
              <SwiperSlide key={i}>
                <RelatedProductSkeleton />
              </SwiperSlide>
            ))
          : items.map((item) => (
              <SwiperSlide key={item?.item_id}>
                <RelatedProduct item={item} key={item.item_id} t={t} />
              </SwiperSlide>
            ))}
      </Swiper>
    </div>
  );
}
